document.addEventListener('DOMContentLoaded', () => {
  const builders = document.querySelectorAll('[data-guide-builder]');

  builders.forEach((builder) => {
    const source = builder.querySelector('[data-guide-source]');
    const lead = builder.querySelector('[data-guide-lead]');
    const nav = builder.querySelector('[data-guide-nav]');
    const modules = builder.querySelector('[data-guide-modules]');

    if (!source || !modules) return;

    const nodes = Array.from(source.childNodes);
    const introNodes = [];
    const groups = [];
    let currentGroup = null;

    nodes.forEach((node) => {
      if (node.nodeType === 1 && node.tagName.toLowerCase() === 'h2') {
        currentGroup = {
          title: node.textContent.trim(),
          nodes: []
        };
        groups.push(currentGroup);
      } else if (currentGroup) {
        currentGroup.nodes.push(node.cloneNode(true));
      } else {
        introNodes.push(node.cloneNode(true));
      }
    });

    const hasIntro = introNodes.some((node) => {
      return (node.textContent || '').trim() !== '' || node.nodeType === 1;
    });

    if (hasIntro) {
      introNodes.forEach((node) => lead.appendChild(node));
    } else {
      lead.remove();
    }

    if (!groups.length) {
      modules.innerHTML = source.innerHTML;
      nav.remove();
      return;
    }

    groups.forEach((group, index) => {
      const id = `guide-module-${index + 1}`;

      const previewText = group.nodes
        .map((node) => (node.textContent || '').replace(/\s+/g, ' ').trim())
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();

      const preview = previewText.length > 120
        ? `${previewText.slice(0, 120)}…`
        : previewText;

      const navLink = document.createElement('a');
      navLink.className = 'guide-article__quick-link';
      navLink.href = `#${id}`;
      navLink.textContent = group.title;
      nav.appendChild(navLink);

      const details = document.createElement('details');
      details.className = 'guide-article__module';
      details.id = id;

      if (index === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.className = 'guide-article__module-summary';

      const summaryTitle = document.createElement('span');
      summaryTitle.className = 'guide-article__module-title';
      summaryTitle.textContent = group.title;

      const summaryPreview = document.createElement('span');
      summaryPreview.className = 'guide-article__module-preview';
      summaryPreview.textContent = preview;

      summary.appendChild(summaryTitle);
      if (preview) summary.appendChild(summaryPreview);

      const body = document.createElement('div');
      body.className = 'guide-article__module-body rte';

      group.nodes.forEach((node) => {
        body.appendChild(node);
      });

      details.appendChild(summary);
      details.appendChild(body);
      modules.appendChild(details);
    });
  });
});
